import { FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";

import { ForgotPasswordRequest } from "@/api/rest/models/auth";
import { forgotPassword } from "@/api/rest/services/authService";

import LoginHelp from "./LoginHelp";

export default function ForgotPasswordForm({ className }: { className?: string }) {
  const { t } = useTranslation();

  // Store state, not translated text, so banners follow language switches.
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitForm = async (e: FormEvent<HTMLFormElement>) => {
    setSent(false);
    setError(null);
    e.preventDefault();
    const data = Object.fromEntries(new FormData(e.currentTarget).entries()) as unknown as ForgotPasswordRequest; // TODO: proper form validation
    try {
      if (await forgotPassword(data)) {
        setSent(true);
      }
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <form className={className} onSubmit={submitForm}>
      <span className="text-gray-500 text-center">{t("login.passwordResetInstructions")}</span>
      <input
        className="border border-gray-300 rounded-md p-2"
        name="email"
        autoComplete="username"
        type="email"
        placeholder={t("login.email")}
        required
      />
      {sent && (
        <span className="rounded-lg p-4 text-center text-md bg-green-300 text-green-900">
          {t("login.resetPasswordFormSuccess")}
        </span>
      )}
      {sent && <LoginHelp />}
      {error && <span className="rounded-lg p-4 text-center text-md bg-red-300 text-red-900">{error}</span>}
      {!sent && <button className="rounded-md p-2">{t("login.resetPassword")}</button>}
      <span className="text-gray-500 text-sm text-center">{t("login.noAccountYet")}</span>
    </form>
  );
}
